import { render } from "./dashboardProducts.vue?vue&type=template&id=b28339c6&scoped=true"
import script from "./dashboardProducts.vue?vue&type=script&lang=js"
export * from "./dashboardProducts.vue?vue&type=script&lang=js"

import "./dashboardProducts.vue?vue&type=style&index=0&id=b28339c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28339c6"]])

export default __exports__